export enum OrderStatuses {
  /**
   * Новый
   */
  NEW = 'new',

  /**
   * Обработка в КС
   */
  PROCESSING_CS = 'processing_cs',

  /**
   * Ждем ТК документы оформлены
   */
  WAIT_TC_DOCS_ISSUED = 'wait_tc_docs_issued',

  /**
   * Готов к выдаче с РгС
   */
  READY_FOR_RGS_PICKUP = 'ready_for_rgs_pickup',

  /**
   * Передача КС
   */
  SEND_CS = 'send_cs',

  /**
   * Готов к отгрузке
   */
  READY_FOR_SHIPMENT = 'ready_for_shipment',

  /**
   * Отгрузить документы
   */
  SHIPMENT_DOCS = 'shipment_docs',

  /**
   * Филиал готов к отгрузке
   */
  FILIAL_SHIPPED = 'filial_shipped',

  /**
   * Отгружен
   */
  SHIPPED = 'shipped',

  /**
   * Отменен
   */
  CANCELED = 'canceled',
}
